import { CountryCode } from "libphonenumber-js";

// This function returns the current locale
// It will be adjusted, in the future, to fetch the user's locale settings
export const getCurrentLocale = (): string => {
  const resolvedLocale = new Intl.NumberFormat().resolvedOptions().locale;
  return (
    resolvedLocale || navigator.languages?.[0] || navigator.language || "en-US"
  );
};

export const getCountryFromCurrentLocale = (): CountryCode => {
  // `Intl.Locale` resolves the actual ISO region subtag, unlike a plain
  // "-" split — which misreads a script-tagged locale like "zh-Hans-CN" as
  // "Hans" (the script) instead of "CN" (the region). `.region` can still be
  // undefined for a locale with no region subtag at all (e.g. bare "en"),
  // and the constructor throws on a malformed locale string, so both fall
  // back to "US" the same way the previous implementation did.
  try {
    const country = new Intl.Locale(getCurrentLocale()).region || "US";
    return country as CountryCode;
  } catch {
    return "US" as CountryCode;
  }
};
